import { useCallback, useEffect, useState } from 'react';
import { getCategoriesWithSubcategories } from '../services/categories';

export function useCategoriesWithSubcategories(enabled = true) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCategories = useCallback(async () => {
    if (!enabled) {
      setCategories([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const res = await getCategoriesWithSubcategories();
      setCategories(res?.data?.categories || []);
    } catch (e) {
      setError(e?.message || 'Failed to load course categories');
      setCategories([]);
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  return { categories, loading, error, refetch: fetchCategories };
}
